module.exports = __webpack_public_path__ + "img/Dantam Makeover 15.2c800a73.jpg";